import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	MatterFormViewerModalComponent,
	MatterFormViewerModalData,
} from '@components/matter-form-viewer/matter-form-viewer-modal/matter-form-viewer-modal.component';
import { PDFFormType } from '@models/matter-form-data';
import { MatterMortgage, MatterMortgagePriority } from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatterFormsDispatch } from '@state/global/forms/selected-matter-forms.dispatch';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { TestHooks } from './form-entry.hooks';

interface FormUrl {
	label: string;
	value: PDFFormType;
}

@Component({
	selector: 'app-form-entry',
	templateUrl: './form-entry.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormEntryComponent {
	testHooks = TestHooks;
	public over25Url: FormUrl = {
		label: 'Over $25M',
		value: PDFFormType.FCT_OVER_25,
	};

	public under25Url: FormUrl = {
		label: 'Under $25M',
		value: PDFFormType.FCT_UNDER_25,
	};

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(MatterMortgagesState.getAllMortgages)
	mortgages: MatterMortgage[];
	@Select(SelectedMatter.titleInsuranceSelectedForm)
	selectedForm$: Observable<string>;

	constructor(
		private matterDispatch: MatterDispatch,
		private dialog: MatDialog,
		private selectedMatterFormsDispatch: SelectedMatterFormsDispatch,
	) {}

	public selectForm(url: string) {
		this.matterDispatch.SetTitleInsuranceSelectedForm(this.matterId, url);
	}

	public openModal(type: 'over' | 'under'): void {
		const formUrl = type === 'over' ? this.over25Url : this.under25Url;
		this.matterDispatch.SetTitleInsuranceSelectedForm(
			this.matterId,
			formUrl.value,
		);
		this.selectedMatterFormsDispatch.SelectForm(formUrl.value);
		const data: MatterFormViewerModalData = {
			formId: formUrl.value,
			mortgageId: this.mortgages?.find(
				(m) => m.priority === MatterMortgagePriority.PRIORITY_1,
			)?.id,
		};

		this.dialog.open(MatterFormViewerModalComponent, {
			data,
			height: '95vh',
			maxWidth: '900px',
			width: '90%',
		});
	}
}
